import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, lifecycle, setPropTypes, withHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import ExPaginationGroup from '../../components/molecules/ExPaginationGroup';

const styles = {
  root: {
    marginTop: 15
  },
  overflow: {
    overflow: 'auto'
  },
  buttonContainer: {
    padding: '10px 26px 10px 26px',
    textAlign: 'right',
    backgroundColor: '#fff'
  },
  button: {
    margin: '5px 5px'
  },
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      ticketsUsedByAdmin: state.ticketsUsedByAdmin.list,
      totalCount: state.ticketsUsedByAdmin.count
    }),
    dispatch => ({
      actions: bindActionCreators({}, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withHandlers({}),
  lifecycle({
    componentDidMount() {}
  })
);

const ticketOptions = [
  {
    label: 'A 社食チケット（上限金額指定）',
    value: 1
  },
  {
    label: 'B 社食チケット（金額×枚数指定）',
    value: 5
  },
  {
    label: 'D 特別手当チケット（メニュー×期限指定）',
    value: 2
  },
  {
    label: 'F 社内交流チケット（金額×枚数×期限指定）',
    value: 4
  },
  {
    label: 'E 褒賞チケット (上限金額指定ｘ期限指定) ',
    value: 7
  }
];

const Main = enhance(
  ({
    classes,
    ticketsUsedByAdmin,
    totalCount,
    rowsPerPage,
    page,
    handleChangePage,
    setRowsPerPage
  }) => {
    function getTicketName(id) {
      const ticket = ticketOptions.find(
        item => Number(item.value) === Number(id)
      );
      return ticket ? ticket.label : '';
    }

    return (
      <div className={classes.root}>
        <div className={classes.scrollTable}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>ユーザーチケットID</TableCell>
                <TableCell>システムID</TableCell>
                <TableCell>ユーザーID</TableCell>
                <TableCell>ユーザー名</TableCell>
                <TableCell>店舗ID</TableCell>
                <TableCell>店舗名</TableCell>
                <TableCell>メニューID</TableCell>
                <TableCell>メニュー名</TableCell>
                <TableCell>ユーザーメールアドレス</TableCell>
                <TableCell>チケット種別</TableCell>
                <TableCell>利用金額</TableCell>
                <TableCell>利用日時</TableCell>
                <TableCell>作成日時</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {ticketsUsedByAdmin &&
                ticketsUsedByAdmin.map(ticket => (
                  <TableRow>
                    <TableCell>{ticket.userTicketIds}</TableCell>
                    <TableCell>{ticket.fromSystemId}</TableCell>
                    <TableCell>{ticket.userId}</TableCell>
                    <TableCell>{ticket.displayName}</TableCell>
                    <TableCell>{ticket.shopId}</TableCell>
                    <TableCell>{ticket.shopName}</TableCell>
                    <TableCell>{ticket.menuId}</TableCell>
                    <TableCell>{ticket.menuName}</TableCell>
                    <TableCell>{ticket.userEmail}</TableCell>
                    <TableCell>{getTicketName(ticket.ticketId)}</TableCell>
                    <TableCell>{ticket.usedPrice}</TableCell>
                    <TableCell>{ticket.usedAt}</TableCell>
                    <TableCell>{ticket.createdAt}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </div>

        <ExPaginationGroup
          count={
            totalCount % rowsPerPage > 0
              ? Math.floor(totalCount / rowsPerPage) + 1
              : Math.floor(totalCount / rowsPerPage)
          }
          selectedPage={page}
          handleChangePage={(e, p, limit) => handleChangePage(e, p, limit)}
          limit={rowsPerPage}
          totalCount={totalCount}
          setLimit={setRowsPerPage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
